import React, { useState } from 'react';
import './Newsletter.css';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  return (
    <section className="newsletter">
      <div className="newsletter-container">
        <div className="newsletter-content">
          <h2 className="newsletter-title">Newsletter</h2>
          <p className="newsletter-subtitle">
            Sign up below to receive travel inspiration, news, offers and expert tips.
          </p>
          <form onSubmit={handleSubmit} className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="newsletter-input"
              required
            />
            <button type="submit" className="newsletter-button">
              {submitted ? '✓ Subscribed!' : 'Sign Up'}
            </button>
          </form>
          <p className="newsletter-consent">
            I consent to receive promotional emails from Sefarium. You can unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>
  );
}

